import { FC, memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ModalProps, ModalTypes } from 'application/providers/ModalProvider';
import { selectStep } from '../slices/createPointsGroup/selectors';
import { resetCreatePointsGroup } from '../slices/createPointsGroup/slice';
import { CREATE_POINTS_GROUP_STEPS } from '../slices/createPointsGroup/consts';
import { SelectPointsGroupTitle } from './SelectTitle';
import SelectPointsGroupPoints from './SelectPointsGroupPoints';
import SelectMasterVideoStream from './SelectMasterVideoStream';

export const CreatePointsGroupModal: FC<ModalProps[ModalTypes.CREATE_POINTS_GROUP]> = memo(({ close }) => {
  const dispatch = useDispatch();
  const currentStep = useSelector(selectStep);

  const handleClose = useCallback(() => {
    dispatch(resetCreatePointsGroup());
    close();
  }, [dispatch, close]);

  const renderStepContent = () => {
    switch (currentStep) {
      case CREATE_POINTS_GROUP_STEPS.TITLE:
        return <SelectPointsGroupTitle close={handleClose} />;
      case CREATE_POINTS_GROUP_STEPS.DEVICES:
        return <SelectPointsGroupPoints close={handleClose} />;
      case CREATE_POINTS_GROUP_STEPS.MASTER_VIDEO_STREAM:
        return <SelectMasterVideoStream close={handleClose} />;
      default:
        return null;
    }
  };

  return <div>{renderStepContent()}</div>;
});
